export const normalizeTrailingSlash = (url: string) => {
  if (url === '/') {
    return url;
  }
  if (url.endsWith('/')) {
    return url.slice(0, -1);
  }
  return url;
};

const getUrlValue = (url: string) => (url !== '/' ? url.split('/').length : 0);

export const compareUrlsBySpecificity = (urlA: string, urlB: string) =>
  getUrlValue(urlA) - getUrlValue(urlB);
